import * as R from 'ramda';
import { BundleData } from '../types';

const sumWeeklyClasses = (bundle: BundleData['selections']) =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  R.pipe(R.pluck('weeklyClasses'), R.values, R.sum)(bundle);

export default sumWeeklyClasses;
